import { AlertTriangle, Clock, Users, TrendingDown } from "lucide-react";

const problems = [
  {
    icon: Clock,
    title: "4-6 Hours Per Bug",
    description: "Engineers spend hours debugging production issues instead of shipping features"
  },
  {
    icon: Users,
    title: "30-40% Time Wasted",
    description: "Engineering teams lose valuable development time to bug firefighting"
  },
  {
    icon: AlertTriangle,
    title: "On-Call Burnout",
    description: "Constant production errors drain team morale and productivity"
  },
  {
    icon: TrendingDown,
    title: "$50-100K Per Engineer",
    description: "Annual cost of debugging time multiplied across your entire team"
  }
];

export const ProblemSection = () => {
  return (
    <section className="py-16 sm:py-24 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 tracking-tight">
            The Bug Crisis Is <span className="text-accent">Real</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto px-4 font-light">
            Production bugs drain your engineering resources, delay feature releases, and cost your company thousands per incident. Here's the hidden tax of manual debugging.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 max-w-4xl mx-auto">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <div 
                key={index}
                className="p-6 sm:p-8 bg-background border border-border rounded-xl hover:shadow-md transition-shadow duration-200"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-muted flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-foreground/60" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold mb-2 font-heading">{problem.title}</h3>
                <p className="text-sm sm:text-base text-muted-foreground font-light">{problem.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};